export default "__VITE_ASSET__DQ$mzB5Q__"